// import Image from "next/image";
// import Guide from "@/components/common/guide/guide";
// import { withTitle } from "@/components/hoc/with_title";
// import ContentCard from "@/components/UI/content-card/content_card";
// import Button from "@/components/UI/button/button";
import style from "./home_structure.module.css";
import { Fragment, useEffect, useState, useContext } from "react";
// import { useRouter } from "next/router";
import CustomerContext from "@/stores/customer-context";
// import { HOME_INFO_KEY } from "@/helpers/constant/enum_data";
import { homeStructures, homeUsageType } from "@/helpers/constant/content_data";
import InputSelect from "@/components/UI/input-select/input_select";

export default function HomeStructure({
  values,
  onChange,
  onBlur,
  errors,
  touched,
}) {
  const [homeStructureList, setHomeStructureList] = useState(homeStructures);
  const [homeStructureOptions, setHomeStructureOption] = useState();
  const [homeStructureValue, setHomeStructureValue] = useState();
  const homeFloor = [1, 2, 3, 4, 5];
  const customerCtx = useContext(CustomerContext);
  const [homeUsageList, setHomeUsageList] = useState(homeUsageType);
  const [homeUsageOptions, setHomeUsageOptions] = useState();
  const [homeUsageValue, setHomeUsageValue] = useState();
  useEffect(() => {
    (async () => {
      const _homeStructureValue = [];
      const _homeStructureOptions = [];
      for (const [key, value] of Object.entries(homeStructureList)) {
        _homeStructureValue.push(key);
        _homeStructureOptions.push(value.title);
      }
      setHomeStructureValue(_homeStructureValue);
      setHomeStructureOption(_homeStructureOptions);

      const _homeUsageOptions = [];
      const _homeUsageValue = [];
      for (const [key, value] of Object.entries(homeUsageList)) {
        _homeUsageValue.push(key);
        _homeUsageOptions.push(value.title);
      }
      setHomeUsageOptions(_homeUsageOptions);
      setHomeUsageValue(_homeUsageValue);
    })();
  }, []);

  return (
    <Fragment>
      <div className={style.input_group}>
        <InputSelect
          name="homeStructure"
          onChange={onChange}
          onBlur={onBlur}
          title={"โครงสร้างบ้าน"}
          placeholder={"กรุณาเลือกโครงสร้างบ้าน"}
          values={homeStructureValue}
          options={homeStructureOptions}
          initValue={values.homeStructure}
          theme="black"
          hasUnChangeState={true}
          withRequredMark={true}
          errorMsg={
            errors.homeStructure && touched.homeStructure
              ? errors.homeStructure
              : ""
          }
        />
      </div>
      <div className={style.input_group}>
        <InputSelect
          name="homeFloor"
          onChange={onChange}
          onBlur={onBlur}
          title={"จำนวนช้ัน"}
          placeholder={"กรุณาเลือกจำนวนชั้น"}
          initValue={values.homeFloor}
          options={homeFloor}
          theme="black"
          hasUnChangeState={true}
          withRequredMark={true}
          errorMsg={
            errors.homeFloor && touched.homeFloor
              ? errors.homeFloor
              : ""
          }
        />
      </div>
      <div className={style.input_group}>
        <InputSelect
          name="homeUsage"
          onChange={onChange}
          onBlur={onBlur}
          title={"การใช้งาน"}
          placeholder={"กรุณาเลือกรูปแแบบการใช้งานบ้าน"}
          values={homeUsageValue}
          options={homeUsageOptions}
          initValue={values.homeUsage}
          theme="black"
          hasUnChangeState={true}
          withRequredMark={true}
          errorMsg={
            errors.homeUsage && touched.homeUsage
              ? errors.homeUsage
              : ""
          }
        />
      </div>
    </Fragment>
  );
}
